import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "modal",
    "presaveButtonContainer",
    "presaveButton",
    "presaveSpinner",
    "presaveResult",
    "presaveLink",
    "presaveError",
    "analyticsButtonContainer",
    "analyticsButton",
    "analyticsSpinner",
    "analyticsResult",
    "analyticsLink",
    "analyticsError"
  ]

  // Make targets optional
  get hasPresaveButton() { return this.hasPresaveButtonTarget }
  get hasAnalyticsButton() { return this.hasAnalyticsButtonTarget }

  static values = {
    albumId: Number
  }

  open(event) {
    event.preventDefault()
    this.modalTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
  }

  close() {
    this.modalTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
  }

  closeOnOverlay(event) {
    if (event.target === this.modalTarget) {
      this.close()
    }
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  async generatePresaveLink() {
    if (!this.hasPresaveButtonTarget) return

    this.presaveButtonTarget.classList.add("hidden")
    this.presaveSpinnerTarget.classList.remove("hidden")
    if (this.hasPresaveErrorTarget) this.presaveErrorTarget.classList.add("hidden")

    try {
      const response = await fetch(`/albums/${this.albumIdValue}/generate_presave_link`, {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
          "Accept": "application/json",
          "Content-Type": "application/json"
        }
      })

      const data = await response.json()

      if (response.ok && data.url) {
        this.presaveLinkTarget.value = data.url
        this.presaveButtonContainerTarget.classList.add("hidden")
        this.presaveResultTarget.classList.remove("hidden")
        // Enable analytics button after presave link is generated
        if (this.hasAnalyticsButtonTarget) {
          this.analyticsButtonTarget.disabled = false
        }
      } else {
        if (this.hasPresaveErrorTarget) {
          this.presaveErrorTarget.textContent = data.error || "Failed to generate link"
          this.presaveErrorTarget.classList.remove("hidden")
        }
        this.presaveButtonTarget.classList.remove("hidden")
        this.presaveSpinnerTarget.classList.add("hidden")
      }
    } catch (error) {
      if (this.hasPresaveErrorTarget) {
        this.presaveErrorTarget.textContent = "An error occurred. Please try again."
        this.presaveErrorTarget.classList.remove("hidden")
      }
      this.presaveButtonTarget.classList.remove("hidden")
      this.presaveSpinnerTarget.classList.add("hidden")
    }
  }

  async generateAnalyticsLink() {
    if (!this.hasAnalyticsButtonTarget) return

    this.analyticsButtonTarget.classList.add("hidden")
    this.analyticsSpinnerTarget.classList.remove("hidden")
    if (this.hasAnalyticsErrorTarget) this.analyticsErrorTarget.classList.add("hidden")

    try {
      const response = await fetch(`/albums/${this.albumIdValue}/generate_analytics_link`, {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
          "Accept": "application/json",
          "Content-Type": "application/json"
        }
      })

      const data = await response.json()

      if (response.ok && data.url) {
        this.analyticsLinkTarget.value = data.url
        this.analyticsButtonContainerTarget.classList.add("hidden")
        this.analyticsResultTarget.classList.remove("hidden")
      } else {
        if (this.hasAnalyticsErrorTarget) {
          this.analyticsErrorTarget.textContent = data.error || "Failed to generate link"
          this.analyticsErrorTarget.classList.remove("hidden")
        }
        this.analyticsButtonTarget.classList.remove("hidden")
        this.analyticsSpinnerTarget.classList.add("hidden")
      }
    } catch (error) {
      if (this.hasAnalyticsErrorTarget) {
        this.analyticsErrorTarget.textContent = "An error occurred. Please try again."
        this.analyticsErrorTarget.classList.remove("hidden")
      }
      this.analyticsButtonTarget.classList.remove("hidden")
      this.analyticsSpinnerTarget.classList.add("hidden")
    }
  }

  copyPresaveLink() {
    navigator.clipboard.writeText(this.presaveLinkTarget.value)
  }

  copyAnalyticsLink() {
    navigator.clipboard.writeText(this.analyticsLinkTarget.value)
  }
}
